import type { RestangularService } from '../../common/restangular.service'
import type * as MemoManagement from '../memo-management/memo-management.component'

import { angular, app } from '../../../app.module'

/**
 * メモ一覧表示用のコンポーネント
 * @class MemoCardListComponentCtrl
 */
class MemoCardListComponentCtrl {
  private objectType: string
  private objectId: string
  private snsType: string
  private groupId: number
  private userId: number
  private memoCount: number
  private memoList: MemoManagement.IMemoData[]
  private newMemo: MemoManagement.IMemoData

  constructor(
    $rootScope,
    private RestangularService: RestangularService
  ) {
    this.groupId = $rootScope.groupId
    this.userId = $rootScope.userId
    this.memoList = []
  }

  /**
   * 初期化
   */
  public $onInit(): void {
    // メモ一覧を取得
    const endpoint = 'memo/'
    const params = {
      object_type: this.objectType,
      object_id: this.objectId,
      sns_type: this.snsType,
      group_id: this.groupId,
      user_id: this.userId,
    }

    this.RestangularService.request('GET', endpoint, params).then((result) => {
      this.memoList = result[0].data
      this.memoCount = result[0].data ? result[0].data.length : 0
      // 最後のメモの箇所に移動
      setTimeout(() => {
        // スクロールターゲット: デフォルトは投稿メモ管理モーダル
        let scrollObject = angular.element('md-dialog')
        let scrollHeight = angular.element('memo-management-modal').innerHeight()

        if (scrollHeight === undefined) {
          scrollObject = angular.element('md-dialog-content')
          scrollHeight =
            angular.element('md-dialog-content .basic-data').innerHeight() +
            angular.element('memo-management').innerHeight()
        }

        scrollObject.scrollTop(scrollHeight)
      })
    })
  }

  /**
   * メモが追加されるイベント
   */
  public $onChanges(): void {
    // 新しいメモが追加される場合、メモ一覧をアップデート
    if (this.newMemo !== undefined) {
      this.memoList.push(this.newMemo)
      // メモ数を変更する
      this.memoCount = this.memoCount + 1
    }
  }
}

app.component('memoCardList', {
  bindings: {
    objectType: '@',
    snsType: '@',
    objectId: '<',
    newMemo: '<',
    memoCount: '=',
    onChangeMemo: '&',
  },
  template: require('./memo-card-list.pug')(),
  controller: MemoCardListComponentCtrl,
})
